// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".clean[data-v-35c0ca18]{grid-gap:var(--spacing-xl-2);display:grid;gap:var(--spacing-xl-2);grid-template-rows:auto 1fr;margin:var(--spacing-md-3);min-height:50vh;text-align:center}.clean__header[data-v-35c0ca18],.clean__main[data-v-35c0ca18]{display:flex;justify-content:center}.clean__main[data-v-35c0ca18]{align-items:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
